import { DataItemFormatter } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import useFetchUserPermissions from '../../../../hooks/permissions/useFetchUserPermissions';
import { getInitialConditionalAction, getRouteToCallback } from '../../../../utils/formattersUtils';
import { hasAnyAlertSelected } from '../Watchlist/AlertPopup/AlertPopup.logic';
import styles from './WatchlistTitleFormatter.module.scss';
import WatchlistAlert from '../WatchlistAlert/WatchlistAlert';

const cx = classNames.bind(styles);

const WatchlistTitleFormatter: DataItemFormatter<string, ReactElement, { onItemClick? }> = ({
  value: title,
  item,
  row,
  configuration,
  props,
}) => {
  const { data: userPermissions } = useFetchUserPermissions();
  const { isDisabled, isHovered, isIndent } = row;
  const routeToCallback = getRouteToCallback(configuration, item);
  const handleClickBeforeRoute = getInitialConditionalAction(configuration, row, props, item);
  const isAnyAlertSelected = hasAnyAlertSelected(userPermissions, item.mode, item.riskProductAlert);

  return (
    <Link to={routeToCallback} className={cx('body')} onClick={handleClickBeforeRoute} data-testid="title-formatter">
      <h2
        className={cx('title', { 'is-disabled': isDisabled, 'is-hovered': isHovered, indent: isIndent })}
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <WatchlistAlert isAnyAlertSelected={isAnyAlertSelected} />
    </Link>
  );
};

export default WatchlistTitleFormatter;
